module.exports = __webpack_public_path__ + "static/media/coffee_hero_tablet.b6710390.jpg";